import {Fragment} from 'react';
import {List, ListItem} from '@mui/material';
import {Grid, Box} from '@jobseeker/lotus/foundations';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import Link from '@jobseeker/lotus/elements/Link';
import {getCatTagPageLink} from '@jobseeker/lotus/utils/link';

import type {Props, TabNav} from './types';
import {isCSR} from '@jobseeker/lotus/utils';

const SeoFooter = (props: Props) => {
  const theme = useWrappedTheme();
  const {tabsList, jobLoading} = props;

  return (
    <Grid
      container
      display={isCSR() ? (jobLoading ? 'none' : 'flex') : 'flex'}
      sx={{
        py: theme.spacing(3),
        px: theme.spacing(4),
        columnGap: theme.spacing(11.25),
        rowGap: theme.spacing(3),
        '@media screen and (min-width: 1024px)': {
          columnGap: 8,
        },
        '@media screen and (min-width: 1280px)': {
          columnGap: 10,
        },
        '@media screen and (min-width: 1336px)': {
          columnGap: 10.5,
        },
        '@media screen and (min-width: 1440px)': {
          columnGap: 11.25,
        },
      }}
    >
      {tabsList?.map((tab: TabNav, indexVal: number) => (
        <Fragment key={`lotus-seo-footer-${indexVal}`}>
          <Grid item xxs={12} sm={2.4}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Link
                href={getCatTagPageLink('/c', tab['tag'])}
                target="_blank"
                // key={`${indexVal}${Date.now()}`}
                sx={{
                  fontWeight: theme.typography.fontWeightMedium,
                  fontSize: theme.typography.pxToRem(14),
                  padding: 0,
                  opacity: 1,
                  cursor: 'pointer',
                  marginBottom: theme.spacing(1.5),
                  wordBreak: 'break-word',
                  whiteSpace: 'normal',
                  color: 'text.secondary',
                  textDecoration: 'none',
                  ':hover': {
                    color: theme.palette.secondary.main,
                    textDecoration: 'none',
                  },
                }}
                onClick={() => {
                  //navToJobCategoryAndTagPage(ROUTE_CATEGORY);
                }}
              >
                {tab['heading']} Jobs{' '}
              </Link>

              <List
                sx={{
                  pt: 0,
                  pl: theme.spacing(3),
                }}
              >
                {tab.menu.slice(0, 6).map((link, index) => (
                  <ListItem
                    component="a"
                    key={`lotus-seofooter-tab-menu-${index}`}
                    title={link['label']}
                    href={getCatTagPageLink('/k', link['tag'])}
                    target="_blank"
                    sx={{
                      display: 'list-item',
                      listStyleType: 'disc',
                      fontSize: theme.typography.pxToRem(14),
                      fontWeight: theme.typography.fontWeightRegular,
                      whiteSpace: 'wrap',
                      cursor: 'pointer',
                      color: theme.palette.secondary.main,
                      wordBreak: 'break-word',
                      ':hover': {
                        color: theme.palette.secondary.main,
                        textDecoration: 'none',
                      },
                      pt: '0px !important',
                      pb: theme.spacing(0.5),
                      px: '0px !important',
                    }}
                  >
                    {link?.label}
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>
        </Fragment>
      ))}
    </Grid>
  );
};

export default SeoFooter;
